import Navbar from "@/components/Navbar";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Key, Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useTranslation } from "@/hooks/useTranslation";
import { useLanguage } from "@/contexts/LanguageContext";
const Giblet = () => {
  const { t } = useTranslation();
  const { currentLanguage, setLanguage } = useLanguage();
  const [isApiKeyDialogOpen, setIsApiKeyDialogOpen] = useState(false);
  const [apiKey, setApiKey] = useState("");
  const [organizationId, setOrganizationId] = useState("");
  const [tempApiKey, setTempApiKey] = useState("");
  const [tempOrganizationId, setTempOrganizationId] = useState("");
  const openApiKeyDialog = () => {
    // Load from localStorage if available
    const savedApiKey = localStorage.getItem("teamgpt_api_key");
    const savedOrgId = localStorage.getItem("teamgpt_org_id");
    setTempApiKey(savedApiKey || apiKey);
    setTempOrganizationId(savedOrgId || organizationId);
    setIsApiKeyDialogOpen(true);
  };
  const saveApiKey = () => {
    if (tempApiKey.trim()) {
      setApiKey(tempApiKey.trim());
      localStorage.setItem("teamgpt_api_key", tempApiKey.trim());

      // Save organization ID if provided
      setOrganizationId(tempOrganizationId.trim());
      if (tempOrganizationId.trim()) {
        localStorage.setItem("teamgpt_org_id", tempOrganizationId.trim());
      } else {
        localStorage.removeItem("teamgpt_org_id");
      }
      toast.success("API credentials updated successfully");
    }
    setIsApiKeyDialogOpen(false);
  };
  return <div className="min-h-screen bg-white">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center animate-fade-in">
          <div className="flex justify-center items-center gap-16 mb-8">
            <Link to="/curt-channel" className="block hover:scale-110 transition-transform">
              <img src="/lovable-uploads/ad94e961-5c47-4e4e-8cfe-e8a9cfdbb7c6.png" alt="Giblet Construct" className="h-24 w-24" />
            </Link>
            <Link to="/ispai-channel">
              <img src="/lovable-uploads/8f124f43-e5cf-46cf-a9a3-f6aa8490055d.png" alt="Giblet" className="h-32 w-32 hover:scale-110 transition-transform" />
            </Link>
            <Link to="/quebec-channel" className="block hover:scale-110 transition-transform">
              <img src="/lovable-uploads/20e8364f-9345-4a1f-8f33-d76f538b5142.png" alt="Quebec Channel" className="h-24 w-24" />
            </Link>
          </div>
          <h1 className="text-4xl font-bold text-black mb-6">{t('giblet.title')}</h1>
          <p className="text-lg text-gray-600 mb-4 max-w-2xl mx-auto">
            {t('giblet.description')}
          </p>
          
          {/* API Credentials button hidden */}

          <Card className="border-2 border-black text-left max-w-3xl mx-auto mb-12">
            <CardContent className="pt-6">
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold mb-4">{t('giblet.whoIsGiblet')}</h3>
                  <div className="space-y-4">
                    <div>
                      <h4 className="font-semibold mb-2">{t('giblet.beginning')}</h4>
                      <p className="text-sm text-gray-700">{t('giblet.beginningText')}</p>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">{t('giblet.becameSpecial')}</h4>
                      <p className="text-sm text-gray-700">{t('giblet.becameSpecialText')}</p>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">{t('giblet.gavePurpose')}</h4>
                      <p className="text-sm text-gray-700 font-normal">{t('giblet.gavePurposeText')}</p>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">{t('giblet.changeWorld')}</h4>
                      <p className="text-sm text-gray-700">{t('giblet.changeWorldText')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      
      <Dialog open={isApiKeyDialogOpen} onOpenChange={setIsApiKeyDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Update Giblet's API Credentials</DialogTitle>
            <DialogDescription>
              Enter your TeamGPT API key and organization ID to connect to the AI service.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div className="space-y-2">
              <Label htmlFor="api-key">API Key</Label>
              <Input id="api-key" type="password" placeholder="sk-proj-xxxxxxxx" value={tempApiKey} onChange={e => setTempApiKey(e.target.value)} className="w-full" />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="org-id" className="flex items-center">
                <span>Organization ID</span>
                <span className="text-xs text-muted-foreground ml-2">(Optional)</span>
              </Label>
              <div className="flex items-center space-x-2">
                <Briefcase className="h-4 w-4 text-muted-foreground" />
                <Input id="org-id" type="text" placeholder="org-xxxxxxxx" value={tempOrganizationId} onChange={e => setTempOrganizationId(e.target.value)} className="w-full" />
              </div>
              <p className="text-xs text-muted-foreground">
                If your API requests require an organization ID, enter it here.
              </p>
            </div>
            
            <p className="text-xs text-muted-foreground">
              Your credentials are stored locally in your browser and never sent to our servers.
            </p>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setIsApiKeyDialogOpen(false)}>
              Cancel
            </Button>
            <Button onClick={saveApiKey}>Save Credentials</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>;
};
export default Giblet;